import React from 'react'
import '../App.css';
import './TechStackSection.css';
import ImageSlider from './ImageSlider';

function TechStackSection() {
    return (
        <div className='tech-stack-container'>

            <h1>Technology Stack</h1>
            <hr class="solid"></hr>
            <p class='subheading'>Check out some of the technologies I'm familiar with</p>
            <div class="slider" data-direction="right" data-speed="fast">
                <div class="slider_inner">
                    <div class='logo-item'><img src="../Images/CSharp Logo.png" alt="" /><span>C#</span></div>
                    <div class='logo-item'><img src="../Images/CSS Logo.png" alt="" /><span>CSS</span></div>
                    <div class='logo-item'><img src="../Images/HTML LOGO.png" alt="" /><span>HTML5</span></div>
                    <div class='logo-item'><img src="../Images/javascript logo.png" alt="" /><span>Javascript</span></div>
                    <div class='logo-item'><img src="../Images/java logo.png" alt="" /><span>Java</span></div>
                    <div class='logo-item'><img src="../Images/Oracle Logo.png" alt="" /><span>Oracle/Sql</span></div>
                    <div class='logo-item'><img src="../Images/Python.png" alt="" /><span>Python</span></div>
                    <div class='logo-item'><img src="../Images/REACTJS Logo.png" alt="" /><span>React JS</span></div>
                    <div class='logo-item'><img src="../Images/Unity Logo.png" alt="" /><span>Unity Game Engine</span></div>
                    <div class='logo-item'><img src="../Images/Wordpress Logo.png" alt="" /><span>Wordpress CMS</span></div>
                    <div class='logo-item'><img src="../Images/Elementor Logo.png" alt="" /><span>Elementor</span></div>
                    <div class='logo-item'><img src="../Images/CSharp Logo.png" alt="" /><span>C#</span></div>
                    <div class='logo-item'><img src="../Images/CSS Logo.png" alt="" /><span>CSS</span></div>
                    <div class='logo-item'><img src="../Images/HTML LOGO.png" alt="" /><span>HTML5</span></div>
                    <div class='logo-item'><img src="../Images/javascript logo.png" alt="" /><span>Javascript</span></div>
                    <div class='logo-item'><img src="../Images/java logo.png" alt="" /><span>Java</span></div>
                    <div class='logo-item'><img src="../Images/Oracle Logo.png" alt="" /><span>Oracle/Sql</span></div>
                    <div class='logo-item'><img src="../Images/Python.png" alt="" /><span>Python</span></div>
                    <div class='logo-item'><img src="../Images/REACTJS Logo.png" alt="" /><span>React JS</span></div>
                    <div class='logo-item'><img src="../Images/Unity Logo.png" alt="" /><span>Unity Game Engine</span></div>
                    <div class='logo-item'><img src="../Images/Wordpress Logo.png" alt="" /><span>Wordpress CMS</span></div>
                    <div class='logo-item'><img src="../Images/Elementor Logo.png" alt="" /><span>Elementor</span></div>
                </div>
            </div >
        </div >



    )


}





export default TechStackSection